// Domain-specific messages stay separate from HTTP transport and caching.
type ErrorBody = {
  error?: {
    message?: string;
    code?: string;
    details?: { loc?: unknown[]; type?: string }[];
  };
};
export function apiErrorMessage(path: string, data: ErrorBody | null): string {
  let message = data?.error?.message || "请求失败，请重试";
  if (path === "/radar/collect" && data?.error?.code === "VALIDATION_ERROR") {
    const fields: Record<string, string> = {
      platform: "平台",
      keyword: "关键词",
      keywords: "监测词",
      include_hot: "热门内容",
      category: "分类",
      period: "时间范围",
      sort: "排序",
      source: "数据来源",
    };
    const details = Array.isArray(data.error.details) ? data.error.details : [];
    const names = [
      ...new Set(
        details.flatMap((detail: { loc?: unknown[] }) => {
          const field = Array.isArray(detail.loc) ? detail.loc[1] : undefined;
          return typeof field === "string" && fields[field]
            ? [fields[field]]
            : [];
        }),
      ),
    ];
    const outdated = details.some(
      (detail: { loc?: unknown[]; type?: string }) =>
        Array.isArray(detail.loc) &&
        ((detail.loc[1] === "sort" && detail.type === "literal_error") ||
          (["include_hot", "keywords"].includes(String(detail.loc[1])) &&
            detail.type === "extra_forbidden")),
    );
    if (outdated) {
      message = `当前后端不支持此次监测的${names.join("、") || "部分字段"}，请更新并重启后端服务后重试。`;
    } else if (names.length) {
      message = `监测请求的${names.join("、")}格式不正确，请检查后重试。`;
    }
  }
  return message;
}
